<template>
    <v-dialog 
        v-model="show"
        :fullscreen="$vuetify.breakpoint.xs"
        persistent
        scrollable
        width="500"
    >
        <v-card>
            <v-card-title>
                <v-icon color="primary">
                    error_outline
                </v-icon>
                {{ title }}
            </v-card-title>
            <v-divider />
            <v-card-text>
                <slot name="errorMessage" />
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-spacer />
                <v-btn
                    style="text-transform: none !important"
                    depressed
                    color="primary"
                    :width="$vuetify.breakpoint.xs ? '90%' : ''"
                    @click="close"
                >
                    Close
                </v-btn>
                <v-spacer v-if="this.$vuetify.breakpoint.xs" />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    props: {
        title: {
            type: String,
            required: true,
        },
        show: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
    }),
    methods: {
        close() {
            this.$emit('close-error-dialog');
        }
    }
};
</script>